const metadata = new Map();
export function defineMetadata(name, value, target) {
    let decorations = metadata.get(target);
    if (!decorations) {
        decorations = new Map();
    }
    decorations.set(name, value);
    metadata.set(target, decorations);
}
export function getOwnMetadata(name, target, _) {
    const decorations = metadata.get(target);
    if (!decorations) {
        return undefined;
    }
    return decorations.get(name);
}
/**
 * USE TOGETHER WITH __inject
 *
 * Inject dependency to a class.
 *
 * @example
 * class RichText {
 *     constructor(@inject(T.RichTextSelection) selection: IRichTextSelection)
 * }
 */
export function inject(token, option = {}) {
    return function (target, propertyKey, parameterIndex) {
        var _a, _b;
        const parameterMap = getOwnMetadata('i', target, propertyKey) || new Map();
        parameterMap.set(parameterIndex, {
            token,
            optional: (_a = option.optional) !== null && _a !== void 0 ? _a : false,
            forwardRef: (_b = option.forwardRef) !== null && _b !== void 0 ? _b : false
        });
        defineMetadata('i', parameterMap, target);
    };
}
/**
 * Angular remove decorators. So we need this helper decorator.
 * https://github.com/angular/angular-cli/issues/9306
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function __inject(token, option = {}, target, propertyKey, parameterIndex) {
    var _a, _b;
    const parameterMap = getOwnMetadata('i', target, propertyKey) || new Map();
    parameterMap.set(parameterIndex, {
        token,
        optional: (_a = option.optional) !== null && _a !== void 0 ? _a : false,
        forwardRef: (_b = option.forwardRef) !== null && _b !== void 0 ? _b : false
    });
    defineMetadata('i', parameterMap, target);
}
/**
 * USE TOGETHER WITH __parent
 *
 * Inject parent to a class.
 *
 * @example
 * class RichText {
 *     constructor(@parent() text: IRichText)
 * }
 */
export function parent() {
    return function (target, propertyKey, parameterIndex) {
        defineMetadata('p', parameterIndex, target);
    };
}
/**
 * Angular remove decorators. So we need this helper decorator.
 * https://github.com/angular/angular-cli/issues/9306
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function __parent(target, propertyKey, parameterIndex) {
    defineMetadata('p', parameterIndex, target);
}
export function DIContainer() {
    return function (target, propertyKey, parameterIndex) {
        defineMetadata('c', parameterIndex, target);
    };
}
/**
 * Angular remove decorators. So we need this helper decorator.
 * https://github.com/angular/angular-cli/issues/9306
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function __container(target, propertyKey, parameterIndex) {
    defineMetadata('c', parameterIndex, target);
}
